<template>
  <div class="environmentalMonitoringList w-full h-full relative">
    <div class="icon-search__input mt-5px mb-5px">
      <el-input class="w-full" placeholder="请输入" v-model="keyword" clearable>
        <i slot="append" class="el-icon-search cursor-pointer" @click="getIotDevicePagedList"></i>
      </el-input>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 100px)"
      class="mt-20px"
      :data="tableData"
      highlight-current-row
      row-key="id"
      @row-click="rowClick"
    >
      <el-table-column :label="`${$t('设备名称')}`" show-overflow-tooltip prop="deviceName">
      </el-table-column>
      <el-table-column :label="`${$t('设备编码')}`" show-overflow-tooltip prop="deviceType">
      </el-table-column>
      <el-table-column
        :label="`${$t('设备位置')}`"
        show-overflow-tooltip
        prop="areaCode"
      ></el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50">
        <template #default="{ row }">
          <div class="w-15 cursor-pointer text-[#00BCC8]" @click="reviewDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="total"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getIotDevicePagedList()"
      :pager-count="3"
    >
    </el-pagination>
    <!-- <div class="tableBox w-full">
      <div class="tableHeader flex">
        <div class="w-40">设备名称</div>
        <div class="w-25">设备编码</div>
        <div class="w-25">设备位置</div>
        <div class="w-10">操作</div>
      </div>
      <div class="tableBody mt-5px">
        <div
          class="tableTr flex"
          v-for="(item, index) in 2"
          :key="item"
          :class="index === 0 ? 'activeBg' : ''"
        >
          <div class="w-40">厂区东门扬尘...</div>
          <div class="w-25">12111</div>
          <div class="w-25">厂区东门</div>
          <div class="w-10 cursor-pointer text-[#00BCC8]" @click="reviewDetail(item)">查看</div>
        </div>
      </div>
    </div> -->
    <EnvironmentDataDialog
      @refresh="refresh"
      v-if="isShowDialog"
      class="w-970px h-500px absolute"
    ></EnvironmentDataDialog>
  </div>
</template>

<script>
import { WisdomSecurityApi } from '@wiz-api/huizhou2'

const wisdomSecurityApi = new WisdomSecurityApi()
const EnvironmentDataDialog = () => {
  return import('./environmentDataDialog')
}
export default {
  name: 'DigitalEngineering',
  components: {
    EnvironmentDataDialog,
  },
  created() {
    this.getIotDevicePagedList()
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNo: 1,
      isShowDialog: false,
      keyword: '',
    }
  },
  methods: {
    rowClick() {},
    async getIotDevicePagedList() {
      const [err, res] = await wisdomSecurityApi.getIotDevicePagedList({
        body: {
          maxResultCount: this.pageSize,
          skipCount: (this.pageNo - 1) * this.pageSize,
          DeviceType: [4],
          areaCode: '',
        },
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
    },
    reviewDetail(item) {
      this.isShowDialog = true
    },
    refresh() {
      this.isShowDialog = false
    },
  },
}
</script>
<style lang="scss" scoped></style>
